import * as QRCode from 'qrcode';
window.Dashboard = (function () {
    var ws;
    var surveyId;

    function setActiveView(activeView) {
        $('[data-view]').hide();
        if (activeView) {
            $('[data-view=' + activeView + ']').show();
        }
    }

    var updateUI = function (phase, message) {
        setActiveView();
        $('#selectedOptionsHeader').hide();
        $('.js-options').empty();

        if (phase === 'Initialized') {
            $('.js-surveyName').html(message.Category.Description);
            $('.js-numUsers').html(message.NumUsers);
            setActiveView('initialized');
        } else if (phase === 'ReadyForStart') {
            setActiveView('readyForStart');
            $('.js-numUsers').html(message.NumUsers);
        } else if (phase === 'Active' || phase === 'Waiting' || phase === 'QuestionsFinished') {
            setActiveView('question');

            switch (phase) {
                case 'Active':
                    $('.presenter-button--show-answers').show();
                    $('.presenter-button--next-question').hide();
                    break;
                case 'Waiting':
                case 'QuestionsFinished':
                    $('.presenter-button--show-answers').hide();
                    $('.presenter-button--next-question').show();
                    break;
            }

            var numTotalAnswers = 0;
            message.ActiveQuestion.Options.forEach(function (option) {
                numTotalAnswers += new Number(option.NumAnswers);
            });
            $('.js-numTotalAnswers').html(numTotalAnswers);

            $('.dashboard-question').toggleClass(
                'dashboard-question--completed',
                phase !== 'Active'
            );
            $('.js-surveyName').html(message.Category.Description);
            $('.js-numUsers').html(message.NumUsers);

            var levelNum = new Number(message.ActiveQuestion.Level.Id + 1);
            var levelMarkup = Array(3)
                .fill()
                .map(function (_, idx) {
                    return levelNum > idx
                        ? '<span class="js-star js-star--filled"></span>'
                        : '<span class="js-star"></span>';
                });

            $('.js-activeLevel').html(levelMarkup);
            $('.js-activeQuestionNum').html(new Number(message.State.ActiveQuestionId + 1));

            populateAnswers(phase, message);

            $('.js-options').attr('data-count', message.ActiveQuestion.Options.length);
            $('.js-activeQuestion').html('<span>' + message.ActiveQuestion.Description + '</span>');

            var textfill = function () {
                // If there are more than 2 options the text needs to be limited to 47 pixels. Otherwise it can be up to 70 pixels
                var maxFontPixels =
                    message.ActiveQuestion.Options.length > 2 && $(window).width() <= 1920
                        ? 47
                        : 70;

                $('.js-activeQuestion').textfill({ maxFontPixels: maxFontPixels });
            };

            textfill();

            var debouncedTextfill = window.Common.debounce(function () {
                textfill();
            }, 250);

            window.removeEventListener('resize', debouncedTextfill);
            window.addEventListener('resize', debouncedTextfill);

            // Change button text when we've reached the last question
            if (parseInt(message.State.ActiveQuestionId) === parseInt(message.NumQuestions - 1)) {
                var $btn = $('.js-advanceButton-finish');
                $btn.text($btn.data().finishText);
            }
        } else if (phase === 'Level') {
            var level = parseInt(message.ActiveQuestion.Level.Id) + 1;
            $('.js-numLevel').html(level);
            $('[data-view=level]').attr('data-level', level);
            $('.dashboard-level__stars .js-star').removeClass('js-star--filled');
            $('.dashboard-level__stars .js-star:lt(' + level + ')').addClass('js-star--filled');
            setActiveView('level');
        } else if (phase === 'SurveyFinished') {
            var totalAverage = window.Common.CalculateAverageAnswerValue(message.Questions);

            var resultMessage;
            if (totalAverage < 0) resultMessage = 'ERROR';

            if (totalAverage < 0.67) {
                resultMessage = message.ResultMessages[0];
                $('#result-advice-green').show();
            } else if (totalAverage < 1.33) {
                resultMessage = message.ResultMessages[1];
                $('#result-advice-yellow').show();
            } else {
                resultMessage = message.ResultMessages[2];
                $('#result-advice-red').show();
            }

            $('.js-result').html(resultMessage);

            $('#completeResults').html('');

            message.Questions.forEach(function (question, idx) {
                $('#completeResults').append(
                    "<div class='complete-results-description'>Fråga " +
                        (idx + 1) +
                        ' - ' +
                        question.Description +
                        '</div>'
                );
                var numAnswers = question.Options.reduce(function (acc, val) {
                    return acc + val.NumAnswers;
                }, 0);

                var highestPercentage = question.Options.reduce(function (acc, option) {
                    var percentage = Math.floor((option.NumAnswers / numAnswers) * 100);
                    if (percentage > acc) {
                        acc = percentage;
                    }
                    return acc;
                }, 0);

                question.Options.forEach(function (option) {
                    var percentage =
                        numAnswers > 0 ? Math.floor((option.NumAnswers / numAnswers) * 100) : 0;

                    var className = '';

                    if (percentage === 0) {
                        className = 'unpicked-answer';
                    } else if (percentage === highestPercentage) {
                        className = 'most-picked-answer';
                    } else {
                        className = 'picked-answer';
                    }

                    $('#completeResults').append(
                        $(
                            "<div class='presenter-question-alternative " +
                                className +
                                "'><div>" +
                                option.Description +
                                '</div></div>'
                        )
                    );
                });
            });

            setActiveView('surveyFinished');
        }
    };

    var populateAnswers = function (phase, message) {
        if (phase === 'Active') {
            message.ActiveQuestion.Options.forEach(function (option) {
                $('.js-options').append(
                    $("<div class='flex-col'>" + option.Description + '</div>')
                );
            });
        } else {
            var numAnswers = message.ActiveQuestion.Options.reduce(function (acc, val) {
                return acc + val.NumAnswers;
            }, 0);
            var highestPercentage = message.ActiveQuestion.Options.reduce(function (acc, option) {
                var percentage = Math.floor((option.NumAnswers / numAnswers) * 100);
                if (percentage > acc) {
                    acc = percentage;
                }
                return acc;
            }, 0);
            message.ActiveQuestion.Options.forEach(function (option) {
                var className = 'flex-col';
                var percentage = Math.floor((option.NumAnswers / numAnswers) * 100);
                if (percentage === 0) {
                    className += ' flex-col--unpicked';
                } else if (percentage === highestPercentage) {
                    className += ' flex-col--most-picked';
                } else {
                    className += ' flex-col--picked';
                }
                $('.js-options').append(
                    $("<div class='" + className + "'><span>" + option.Description + '<span></div>')
                );
            });
        }
    };

    var initDashboardWsListeners = function () {
        if (!ws) {
            console.error('Failed to init listener, connection not ready');
            return;
        }

        ws.onopen = function (e) {
            console.log('Connection open', e);
        };

        ws.onclose = function (e) {
            console.log('Connection closed', e);
        };

        ws.onmessage = function (e) {
            var message = JSON.parse(e.data);
            var phase = window.Common.PhaseIntToString(message.State.ActivePhase);
            console.log('Message received:', e, 'Parsed message:', message, 'New phase:', phase);
            updateUI(phase, message);
        };
    };

    var checkConnectionState = function () {
        if (!ws || ws.readyState !== 1) {
            console.error('Connection not open', ws);
            return false;
        }
        return true;
    };

    var initKeepAliveLoop = function () {
        var interval = setInterval(function () {
            if (!checkConnectionState()) {
                clearInterval(interval);
                return;
            }
            ws.send('');
        }, 5000);
    };

    var initDashboardInteraction = function () {
        $('.js-advanceButton').click(function () {
            if (!checkConnectionState) return;
            ws.send(JSON.stringify({ surveyId: surveyId, instruction: 'advance' }));
        });

        $('.js-gobackButton').click(function () {
            if (!checkConnectionState) return;
            ws.send(JSON.stringify({ surveyId: surveyId, instruction: 'goback' }));
        });

        $('#startButton').click(function () {
            if (!checkConnectionState) return;
            ws.send(JSON.stringify({ surveyId: surveyId, instruction: 'advance' }));
        });

        $('#finishButton').click(function () {
            if (!checkConnectionState) return;
            ws.send(JSON.stringify({ surveyId: surveyId, instruction: 'advance' }));
        });

        $('.js-selectable-text').click(function () {
            var selectText = function (elem) {
                var selection = window.getSelection();
                var range = document.createRange();

                range.selectNodeContents(elem);
                selection.removeAllRanges();
                selection.addRange(range);
            };

            selectText($(this).get(0));
        });

        $('.save-button--email').click(function (ev) {
            $('.email-modal, .email-modal-backdrop').removeClass('is-hidden');
        });

        $('.email-modal-backdrop').click(function (ev) {
            $('.email-modal, .email-modal-backdrop').addClass('is-hidden');
        });

        $('.email-modal').submit(function (ev) {
            ev.preventDefault();
            if (!$(this)[0].checkValidity()) {
                return;
            }

            var $input = $('.email-modal input');
            var email = $input.val();
            var surveyId = $input.data('surveyId');
            var url = $input.data('url');
            url = url.substring(0, url.length - 1); // Remove trailing slash

            var $error = $('.email-modal__error');
            var $success = $('.email-modal__success');

            $error.addClass('is-hidden');

            $.post(url + '?toAddress=' + email + '&surveyId=' + surveyId, function (isSuccessful) {
                if (isSuccessful) {
                    $success.removeClass('is-hidden');
                    $('.email-modal label, .email-modal button').hide();
                } else {
                    $error.removeClass('is-hidden');
                }
            }).fail(function () {
                $error.removeClass('is-hidden');
            });
        });
    };

    var openConnection = function (url) {
        console.log('Opening websocket connection...');
        ws = new WebSocket(url);
    };

    var renderUrlQrCode = function () {
        var urlElement = document.getElementById('livesurvey-url');
        var canvas = document.getElementById('livesurvey-url-qr-code');
        if (!urlElement || !canvas) {
            return;
        }

        QRCode.toCanvas(canvas, urlElement.innerText, { width: 400 }, function (error) {
            if (error) console.error(error);
            canvas.classList.remove('d-none');
        });
    };

    var initDashboard = function (id) {
        surveyId = id;
        var wsProtocol = window.location.protocol.indexOf('https') !== -1 ? 'wss://' : 'ws://';
        openConnection(
            wsProtocol +
                window.location.hostname +
                '/API/LiveSurvey/Connect?id=' +
                surveyId +
                '&dashboard=true'
        );
        initDashboardWsListeners();
        initKeepAliveLoop();
        initDashboardInteraction();
    };

    renderUrlQrCode();

    return {
        Init: initDashboard
    };
})();
